import { initPreferences } from '@vben/preferences'
import { treeToArray, unmountGlobalLoading } from '@vben/utils'

import { cloneDeep, merge } from 'lodash-es'

import { destroyApp } from './bootstrap'
import { getMicroApp, getMicroAppName, isInMicroApp } from './micro-app'
import { overridesPreferences } from './preferences'
import { accessRoutes, destroyRouter } from './router'

/**
 * 应用初始化完成之后再进行页面加载渲染
 */
async function initApplication() {
  if (isInMicroApp()) {
    getMicroApp().setGlobalData({
      frontRouteMap: {
        [getMicroAppName()]: cloneDeep(treeToArray(accessRoutes)),
      },
    })
  }
  // name用于指定项目唯一标识
  // 用于区分不同项目的偏好设置以及存储数据的key前缀以及其他一些需要隔离的数据
  const env = import.meta.env.PROD ? 'prod' : 'dev'
  const appVersion = import.meta.env.VITE_APP_VERSION
  const namespace = `${import.meta.env.VITE_APP_NAMESPACE}-${appVersion}-${env}`

  // app偏好设置初始化
  await initPreferences({
    namespace,
    overrides: isInMicroApp()
      ? merge(
          {},
          overridesPreferences,
          await getMicroApp()?.getGlobalData('preferences'),
          {
            app: {
              accessMode: 'backend',
            },
            sidebar: {
              enable: false,
            },
            header: {
              enable: false,
            },
            tabbar: {
              // enable: false,
              show: false,
            },
            footer: {
              enable: false,
            },
            copyright: {
              enable: false,
            },
            transition: {
              loading: false,
            },
          },
        )
      : overridesPreferences,
    escapeKeys: ['theme.mode', 'app.locale'],
  })

  // 启动应用并挂载
  // vue应用主要逻辑及视图
  const { bootstrap } = await import('./bootstrap')
  await bootstrap(namespace)

  // 移除并销毁loading
  unmountGlobalLoading()
}

window.mount = () => {
  initApplication()
}

window.unmount = () => {
  destroyRouter()
  destroyApp()
}

if (!isInMicroApp()) {
  window.mount()
}
